import React, { useEffect, useMemo, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
// import Country from "@assets/Json/Country_and_cites.json";
// import IndiaCountry from "@assets/Json/India_cities.json";
import moment from "moment";
// import Select from "react-select";
// // Core components
// import Img from "@assets/img";
// import BreadcrumbNav from "@components/BreadcrumbNav/BreadcrumbNav";
// import HeaderBar from "@components/HeaderBar";
// import Navigate from "@components/Navigator";
// import PopUp from "@components/PopUp";
// import ReferFriend from "@components/ReferFriend";
// import Sidebar from "@components/SideBar";
import { Errors } from "@const/error";
// import { TicketSource, TicketType } from "@const/profile";
import { updateUser } from "@store/authReducer";
import { useDispatch } from "react-redux";
import _ from "lodash";

//Api Call
import {
  deleteUserAccount,
  getProfile,
  // receiveTickets,
  // subscribeNewsLetters,
  updateProfile,
  validateInfoUser,
} from "@network/Profile";
import { trackUserEvent } from "@utils/analytics";

/** Style */
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { clearStateAndPersist } from "@store/store";
// import * as S from "./style";
// import { ThreeCircles } from "react-loader-spinner";
// import useDataSideBar from "src/hooks/useDataSideBar";
// import { reverifiedEmail } from "@network/Auth/apiAuth";
// import { ActionSubscribe } from "@network/Profile/type";
// import HeroRaffle from "@components/DashboardBox/HeroRaffle";

interface IFormInput {
  username: string;
  firstName: string;
  lastName: string;
  gender?: string;
  dateOfBirth?: string;
  email: string;
  phoneNumber: string;
  country?: string;
  province?: string;
  address?: string;
  pincode?: string;
  subscribeNewsLetter?: boolean;
}

// const RESEND_TIMEOUT_SECONDS = 60;

const errorMessage: Record<string, string> = {
  required: "This field is required",
  pattern: "Contains invalid characters",
};

enum ValidationResponseCode {
  USERNAME_EXISTED = "USERNAME_EXISTED",
  PHONENUMBER_EXISTED = "PHONENUMBER_EXISTED",
  EMAIL_EXISTED = "EMAIL_EXISTED",
  ERROR = "ERROR",
}

const optionsGender = [
  {
    value: "MALE",
    label: "Male",
  },
  {
    value: "FEMALE",
    label: "Female",
  },
  {
    value: "OTHER",
    label: "Other",
  },
];

// const optionsProvince = IndiaCountry.cities?.map((province) => ({
//   value: province,
//   label: province,
// }));

// const Checkbox = ({
//   label,
//   checked,
//   onChange,
//   register,
// }: {
//   label: string;
//   checked: boolean;
//   register: () => Record<string, unknown>;
//   onChange: () => void;
// }) => {
//   return (
//     <S.CheckboxWrapper onClick={onChange}>
//       <S.HiddenCheckbox {...register()} />
//       <S.StyledCheckbox checked={checked} />
//       <S.Label className="mb-0">{label}</S.Label>
//     </S.CheckboxWrapper>
//   );
// };

const Profile: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [country] = useState<string>(IndiaCountry.name);
  // const [isChecked, setIsChecked] = useState(false);
  // const receiveNewsLetters = useRef<boolean>(false);
  // const [navbar, setNavbar] = useState(false);
  // const [visiblePopup, setVisiblePopup] = useState(false);
  const [timerLeft, setTimerLeft] = useState(0);
  // const [resendEmail, setResendEmail] = useState("");
  const [profileValues, setProfileValues] = useState<any>();
  // const [isFocusOnEmail, setIsFocusOnEmail] = useState(false);
  // const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const { DataSideDashboardBar } = useDataSideBar();

  const [canEdit, setCanEdit] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const defaultFormValues = useMemo(() => {
    if (!profileValues)
      return {
        username: "",
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        gender: "",
        email: "",
        phoneNumber: "",
        province: "",
        address: "",
        subscribeNewsLetter: false,
        pincode: "",
      };
    const {
      username,
      firstName,
      lastName,
      dateOfBirth,
      gender,
      email,
      phoneNumber,
      province,
      address,
      subscribeNewsLetter,
      pincode,
    } = profileValues;
    return {
      username,
      firstName,
      lastName,
      dateOfBirth,
      gender,
      email,
      phoneNumber,
      province,
      address,
      subscribeNewsLetter: subscribeNewsLetter === 1 ? true : false,
      pincode,
    };
  }, [profileValues]);

  const {
    setValue,
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<IFormInput>({
    defaultValues: defaultFormValues,
  });
  const watchGender = watch("gender");
  // const checkedNewsletter = watch("subscribeNewsLetter");
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  // const pastDate = new Date(
  //   currentDate.getFullYear() - 100,
  //   currentDate.getMonth(),
  //   currentDate.getDate()
  // );
  // const minDate = pastDate.toISOString().split("T")[0];
  // const maxDate = currentDate.toISOString().split("T")[0];

  useEffect(() => {
    reset(defaultFormValues);
  }, [defaultFormValues]);

  // const isAtLeast18 = (selectedDate: string) => {
  //   const today = new Date();
  //   const birthDate = new Date(selectedDate);
  //   const age = today.getFullYear() - birthDate.getFullYear();
  //   const monthDiff = today.getMonth() - birthDate.getMonth();
  //   const dayDiff = today.getDate() - birthDate.getDate();
  //   if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
  //     return age - 1 >= 18;
  //   }
  //   return age >= 18;
  // };

  // const onChangeDateOfBirth = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = e.target.value;
  //   const min = new Date(minDate);
  //   const max = new Date(maxDate);
  //   const selectedDate = new Date(value);
  //   if (value.length === 10) {
  //     switch (true) {
  //       case selectedDate < min || selectedDate > max:
  //         setError("dateOfBirth", {
  //           message: "You must be at least 18 years old.",
  //         });
  //         break;
  //       case !isAtLeast18(value):
  //         setError("dateOfBirth", {
  //           message: "You must be at least 18 years old.",
  //         });
  //         break;
  //       default:
  //         setValue("dateOfBirth", value);
  //         clearErrors("dateOfBirth");
  //         break;
  //     }
  //   }
  // };
  const onSubmit: SubmitHandler<IFormInput> = async (data: IFormInput) => {
    // setResendEmail("");
    if (Object.keys(errors).length === 0) {
      const dateOfBirth = data.dateOfBirth
        ? moment(data.dateOfBirth).format("YYYY/MM/DD")
        : undefined;
      const email = data.email || undefined;
      const dataUpdate = _.omit(data, ["subscribeNewsLetter"]);
      const username = dataUpdate.username || undefined;
      const profileDataUpdate: any = {
        ...dataUpdate,
        dateOfBirth,
        email,
        username,
      };
      try {
        setIsLoading(true);
        const updateProfileRes = await updateProfile(profileDataUpdate);
        if (updateProfileRes.status === "error") {
          toast.error(updateProfileRes.message);
          return;
        }
        if (updateProfileRes.data.sendMailVerifyEmail) {
          // setResendEmail("Resend email");
          // toast.info("Check your email to complete the verification process.");
          setCanEdit(false);
          // setIsFocusOnEmail(false);
        }
        const newData = await getProfile();
        dispatch(updateUser({ user: newData.data.profile }));

        if (updateProfileRes.data.receiveTicket) {
          // Profile completed and ticket received - redirect to /ticket
          toast.success("Profile completed! You received 1 ticket as a reward!");
          // Track profile completion
          trackUserEvent.profileUpdate("profile_completed");
          trackUserEvent.ticketEarned("profile_completion", 1);
          // Small delay to show the toast before redirecting
          setTimeout(() => {
            navigate('/ticket');
          }, 1000);
        } else {
          toast.success("Update profile successfully");
          // Track profile update
          const updatedFields = Object.keys(profileDataUpdate).filter(
            key => profileDataUpdate[key] !== undefined && profileDataUpdate[key] !== null
          );
          updatedFields.forEach(field => trackUserEvent.profileUpdate(field));
          setCanEdit(false);
        }
      } catch (error: any) {
        toast.error(Errors.PROFILE_UPDATED_ERROR);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // const onReceiveNewsLetters = async () => {
  //   setIsChecked(!isChecked);
  //   receiveNewsLetters.current = !receiveNewsLetters.current;
  //   if (receiveNewsLetters.current) {
  //     const response = await subscribeNewsLetters({
  //       action: ActionSubscribe.SUBSCRIBE,
  //     });
  //     if (response.status === "success") {
  //       toast.success("Subscribe successfully!");
  //     }
  //   } else {
  //     const response = await subscribeNewsLetters({
  //       action: ActionSubscribe.UNSUBSCRIBE,
  //     });
  //     if (response.status === "success") {
  //       toast.success("Unsubscribe successfully!");
  //     }
  //   }
  // };

  // const handleChangeUsername = _.debounce(async (value: string) => {
  //   const res = await validateInfoUser({ username: value });
  //   if (res.status === "success") {
  //     setValue("username", value);
  //     clearErrors("username");
  //   } else if (res.status === "error") {
  //     if (res.errorCode === ValidationResponseCode.USERNAME_EXISTED) {
  //       setError("username", {
  //         message: "Username already exists",
  //       });
  //     }
  //   }
  // }, 500);

  const handleChangeEmail = _.debounce(async (value: string) => {
    const res = await validateInfoUser({ email: value });
    if (res.status === "success") {
      setValue("email", value);
      clearErrors("email");
    } else if (res.status === "error") {
      if (res.errorCode === ValidationResponseCode.EMAIL_EXISTED) {
        setError("email", {
          message: "Email already exists",
        });
      }
    }
  }, 500);

  const handleDeleteAccount = async () => {
    try {
      setIsDeleting(true);
      // TODO: Add your delete account API call here
      const response = await deleteUserAccount();
      if (response.status === "error") {
        toast.error(response.message);
        return;
      }

      // For now, just show success message
      toast.success("Account deleted successfully!");

      // Redirect to login or home page after deletion
      setTimeout(() => {
        clearStateAndPersist();
        navigate('/login');
      }, 2000);

    } catch (error: any) {
      console.error("Error deleting account:", error);
      toast.error("Failed to delete account. Please try again.");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  // const onResendEmail = async () => {
  //   try {
  //     if (timerLeft > 0) return;
  //     setTimerLeft(RESEND_TIMEOUT_SECONDS);
  //     const res = await reverifiedEmail({
  //       email: profileValues.email,
  //       userId: profileValues.id,
  //       name: profileValues.fullName,
  //     });
  //     if (res.status === "success") {
  //       toast.success("Re-send email to verify successfully!");
  //     }
  //   } catch (err) {
  //     console.log("err", err);
  //   }
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getProfile();
        setProfileValues(response.data.profile);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (timerLeft > 0) {
      setTimeout(() => setTimerLeft(timerLeft - 1), 1000);
    }
  }, [timerLeft]);

  // useEffect(() => {
  //   if (checkedNewsletter) {
  //     setIsChecked(checkedNewsletter);
  //     receiveNewsLetters.current = checkedNewsletter;
  //   }
  // }, [checkedNewsletter]);

  // const HandleCancel = () => {
  //   setVisiblePopup(false);
  // };

  return (
    <>
      {/* Modern Profile Hero Section */}
      <section className="relative bg-gradient-to-br from-[#4B975B] via-[#5dad6d] to-[#4B975B] overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-40 h-40 md:w-64 md:h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
        </div>

        <div className="relative container mx-auto px-4 md:px-6 lg:px-12 py-12 md:py-16 lg:py-24">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-8 lg:gap-12">

            {/* Left Content */}
            <div className="flex-1 text-white space-y-4 md:space-y-6">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 md:gap-3 bg-white/20 backdrop-blur-sm px-4 md:px-5 py-2 md:py-3 rounded-full">
                <svg className="w-4 h-4 md:w-5 md:h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
                <span className="text-xs md:text-sm font-semibold uppercase tracking-wide">Your Account</span>
              </div>

              {/* Main Heading */}
              <h1 className="text-3xl md:text-4xl font-extrabold leading-tight">
                My Profile
              </h1>

              {/* Subheading */}
              <p className="text-sm md:text-lg text-white/90 max-w-xl">
                Manage your personal information and preferences. Keep your profile up to date for the best experience.
              </p>

              {/* Profile Stats */}
              <div className="flex flex-wrap gap-4 pt-4">
                <div className="flex-1 bg-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 border border-white/20">
                  <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-xs sm:text-sm text-white/80">Status</span>
                  </div>
                  <p className="text-sm sm:text-lg font-bold text-white">
                    {profileValues?.emailVerified ? 'Verified' : 'Pending'}
                  </p>
                </div>

                <div className="flex-1 bg-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 border border-white/20">
                  <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    <span className="text-xs sm:text-sm text-white/80">Email</span>
                  </div>
                  <p className="text-xs sm:text-sm font-semibold text-white truncate">
                    {profileValues?.email || 'Not set'}
                  </p>
                </div>

                <div className="flex-1 bg-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 border border-white/20">
                  <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <span className="text-xs sm:text-sm text-white/80">Phone</span>
                  </div>
                  <p className="text-xs sm:text-sm font-semibold text-white">
                    {profileValues?.phoneNumber || 'Not set'}
                  </p>
                </div>
              </div>

              {/* Stats */}
              <div className="flex flex-wrap gap-4 sm:gap-6 pt-4 sm:pt-6 border-t border-white/20">
                <div className="flex items-center gap-1 sm:gap-2">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-xs sm:text-sm font-medium">Secure Account</span>
                </div>
                <div className="flex items-center gap-1 sm:gap-2">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                  </svg>
                  <span className="text-xs sm:text-sm font-medium">Privacy Protected</span>
                </div>
                <div className="flex items-center gap-1 sm:gap-2">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                  </svg>
                  <span className="text-xs sm:text-sm font-medium">24/7 Access</span>
                </div>
              </div>
            </div>

            {/* Right Content - Profile Avatar */}
            <div className="flex-shrink-0 w-64 sm:w-72 lg:w-80 xl:w-96">
              <div className="relative">
                {/* Glow Effect */}
                <div className="absolute inset-0 bg-white/20 rounded-full blur-2xl sm:blur-3xl"></div>

                {/* Profile Display */}
                <div className="relative bg-white/10 backdrop-blur-md rounded-3xl p-8 sm:p-12 border border-white/20 shadow-2xl">
                  <div className="text-center space-y-4 sm:space-y-6">
                    {/* Avatar */}
                    <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto bg-white rounded-full flex items-center justify-center shadow-xl">
                      {profileValues?.profilePicture ? (
                        <img
                          src={profileValues.profilePicture}
                          alt="Profile"
                          className="w-full h-full rounded-full object-cover"
                        />
                      ) : (
                        <svg className="w-12 h-12 sm:w-20 sm:h-20 text-[#4B975B]" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>

                    {/* User Info */}
                    <div className="text-white">
                      <p className="text-lg sm:text-2xl font-bold mb-1 sm:mb-2">
                        {profileValues?.firstName && profileValues?.lastName
                          ? `${profileValues.firstName} ${profileValues.lastName}`
                          : profileValues?.username || 'User'}
                      </p>
                      <p className="text-xs sm:text-sm opacity-80">@{profileValues?.username || 'username'}</p>
                    </div>

                    {/* Edit Button */}
                    {canEdit && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setCanEdit(false);
                        }}
                        className="w-full bg-white text-[#4B975B] py-2 sm:py-3 px-4 sm:px-6 rounded-xl font-semibold hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2"
                      >
                        <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                        </svg>
                        Edit Profile
                      </button>
                    )}
                  </div>
                </div>

                {/* Floating Badge */}
                {profileValues?.emailVerified && (
                  <div className="absolute -top-3 sm:-top-4 -right-3 sm:-right-4 bg-green-400 text-green-900 px-3 sm:px-4 py-1 sm:py-2 rounded-full font-bold text-xs sm:text-sm shadow-lg">
                    Verified ✓
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg className="w-full h-8 sm:h-12 md:h-16" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" />
          </svg>
        </div>
      </section>

      {/* <div className="container mx-auto px-4 md:px-6 lg:px-8 py-8"></div> */}

      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-8">
        {/* Profile Form Card */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
          {/* Header */}
          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1f2c2b] mb-2">Edit Profile Information</h2>
            <p className="text-[#6a7b76]">Update your personal details and account settings</p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            {/* Username */}
            {/* <div>
              <label className="block text-sm font-semibold text-[#1f2c2b] mb-2">
                Username <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="w-5 h-5 text-[#6a7b76]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                </div>
                <input
                  disabled={true}
                  {...register("username")}
                  maxLength={50}
                  defaultValue={profileValues?.username}
                  placeholder="Enter your username"
                  className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#4B975B] focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
              </div>
              {errors.username && (
                <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {errors.username.message}
                </p>
              )}
            </div> */}

            {/* First Name & Last Name */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-[#1f2c2b] mb-2">
                  First Name
                </label>
                <input
                  disabled={!canEdit}
                  {...register("firstName")}
                  defaultValue={profileValues?.firstName}
                  maxLength={50}
                  placeholder="Enter your first name"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#4B975B] focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                {errors.firstName && (
                  <p className="mt-2 text-sm text-red-600">{errorMessage[errors.firstName.type]}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-[#1f2c2b] mb-2">
                  Last Name
                </label>
                <input
                  disabled={!canEdit}
                  {...register("lastName")}
                  defaultValue={profileValues?.lastName}
                  maxLength={50}
                  placeholder="Enter your last name"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#4B975B] focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                {errors.lastName && (
                  <p className="mt-2 text-sm text-red-600">{errorMessage[errors.lastName.type]}</p>
                )}
              </div>
            </div>

            {/* Email Field */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="block text-sm font-semibold text-[#1f2c2b]">
                  Email Address <span className="text-red-500">*</span>
                </label>
                {/* {!profileValues?.emailVerified && (
                  <button
                    type="button"
                    onClick={onResendEmail}
                    className="text-sm text-[#4B975B] hover:text-[#5dad6d] font-semibold"
                  >
                    {resendEmail && resendEmail} {timerLeft > 0 ? `in ${timerLeft}s` : ""}
                  </button>
                )} */}
              </div>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="w-5 h-5 text-[#6a7b76]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <input
                  disabled={profileValues?.emailVerified || !canEdit}
                  {...register("email")}
                  maxLength={50}
                  placeholder="Enter your email"
                  defaultValue={profileValues?.email}
                  onChange={(e) => {
                    if (!profileValues?.emailVerified && canEdit) {
                      handleChangeEmail(e.target.value);
                    }
                  }}
                  className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#4B975B] focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                {profileValues?.emailVerified && (
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                    <span className="inline-flex items-center gap-1 text-green-600 text-sm font-semibold">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Verified
                    </span>
                  </div>
                )}
              </div>
              {errors.email?.message && (
                <p className="mt-2 text-sm text-red-600">{errors.email.message}</p>
              )}
            </div>

            {/* Phone Number Field */}
            <div>
              <label className="block text-sm font-semibold text-[#1f2c2b] mb-2">
                Phone Number
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="w-5 h-5 text-[#6a7b76]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                </div>
                <input
                  disabled={true}
                  {...register("phoneNumber")}
                  maxLength={10}
                  defaultValue={profileValues?.phoneNumber}
                  placeholder="Enter your phone number"
                  className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#4B975B] focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
              </div>
              {errors.phoneNumber && (
                <p className="mt-2 text-sm text-red-600">{errors.phoneNumber.message}</p>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              {/* Gender Field */}
              <div>
                <label className="block text-sm font-semibold text-[#1f2c2b] mb-2">
                  Gender
                </label>
                <div className="relative">
                  <select
                    disabled={!canEdit}
                    {...register("gender")}
                    defaultValue={profileValues?.gender || ""}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#4B975B] focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none"
                  >
                    <option value="">Select your gender</option>
                    {optionsGender.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-[#6a7b76]" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
                {errors.gender && (
                  <p className="mt-2 text-sm text-red-600">{errors.gender.message}</p>
                )}
              </div>
              {/* Pincode Field */}
              <div>
                <label className="block text-sm font-semibold text-[#1f2c2b] mb-2">
                  Pincode
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="w-5 h-5 text-[#6a7b76]" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V3z" />
                    </svg>
                  </div>
                  <input
                    disabled={!canEdit}
                    {...register("pincode", {
                      pattern: {
                        value: /^[0-9]{6}$/,
                        message: "Pincode must be 6 digits",
                      },
                    })}
                    maxLength={6}
                    placeholder="Enter your pincode"
                    defaultValue={profileValues?.pincode}
                    className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#4B975B] focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                  />
                </div>
                {errors.pincode && (
                  <p className="mt-2 text-sm text-red-600">{errors.pincode.message}</p>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4 border-t">
              {canEdit ? (
                <>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="flex-1 bg-gradient-to-r from-[#4B975B] to-[#5dad6d] text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {isLoading ? (
                      <>
                        <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Saving...
                      </>
                    ) : (
                      <>
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        Save Changes
                      </>
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setCanEdit(false);
                    }}
                    className="flex-1 bg-gray-200 text-[#1f2c2b] py-3 px-6 rounded-xl font-semibold hover:bg-gray-300 transition-all duration-200 flex items-center justify-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" />
                    </svg>
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCanEdit(true);
                  }}
                  className="w-full bg-gradient-to-r from-[#4B975B] to-[#5dad6d] text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                  </svg>
                  Edit Profile
                </button>
              )}

              {/* Debugging logs should not be in JSX */}
            </div>
          </form>
        </div>
      </div>

      {/* Delete Account Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn" onClick={() => setShowDeleteModal(false)}>
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-scaleIn" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button
              onClick={() => setShowDeleteModal(false)}
              className="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              <FontAwesomeIcon icon={faTimes} className="w-4 h-4 text-gray-600" />
            </button>

            {/* Header */}
            <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 text-center">
              <div className="mb-4">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full">
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">
                Delete Account
              </h2>
              <p className="text-red-100 text-lg font-medium">
                This action cannot be undone
              </p>
            </div>

            {/* Content */}
            <div className="p-6 space-y-6">
              {/* Warning Message */}
              <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4">
                <div className="flex items-start gap-3">
                  <svg className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  <div>
                    <h3 className="text-red-800 font-bold text-lg mb-2">Warning!</h3>
                    <p className="text-red-700 text-sm leading-relaxed">
                      Deleting your account will permanently remove all of your data, including:
                    </p>
                  </div>
                </div>
              </div>

              {/* What will be deleted list */}
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0"></div>
                  <span className="text-sm">Your profile information and account details</span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0"></div>
                  <span className="text-sm">All raffle entries and ticket history</span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0"></div>
                  <span className="text-sm">Earned rewards and coupon codes</span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0"></div>
                  <span className="text-sm">Referral progress and connections</span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <div className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0"></div>
                  <span className="text-sm">All associated data and preferences</span>
                </div>
              </div>

              {/* Confirmation Text */}
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                <p className="text-gray-800 text-sm font-semibold text-center">
                  Are you absolutely sure you want to delete your account?
                </p>
                <p className="text-gray-600 text-xs text-center mt-2">
                  This action is permanent and cannot be reversed.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="flex-1 bg-gray-200 text-gray-800 py-3 px-6 rounded-xl font-semibold hover:bg-gray-300 transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" />
                  </svg>
                  Cancel
                </button>
                <button
                  onClick={handleDeleteAccount}
                  disabled={isDeleting}
                  className="flex-1 bg-gradient-to-r from-red-500 to-red-600 text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg hover:from-red-600 hover:to-red-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {isDeleting ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className="w-5 h-5" />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faTrash} className="w-5 h-5" />
                      Yes, Delete My Account
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* create a section where youwill see that you want to delete your account then click here  */}

      {/* Delete Account Section */}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-8">
        <div className="bg-gray-50 border border-gray-200 rounded-xl shadow-md p-4 md:p-6">
          <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-3">
            Want to delete your account?
          </h2>
          <p className="text-sm md:text-base text-gray-600 mb-4">
            Deleting your account will permanently remove all your data. This action cannot be undone.
          </p>
          <button
            onClick={() => setShowDeleteModal(true)}
            className="bg-gradient-to-r from-red-500 to-red-600 text-white py-2 px-4 rounded-lg font-medium hover:bg-gray-300 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            Delete My Account
          </button>
        </div>
      </div>
      {/* <S.Wrapper>
        <Sidebar sideData={DataSideDashboardBar} />
        <S.ContainerNavigate className={navbar ? "activeBg" : ""}>
          <Navigate />
          <BreadcrumbNav />
        </S.ContainerNavigate>

        <ReferFriend />

        <PopUp
          visible={visiblePopup}
          title="Warning"
          footer={true}
          onCancel={() => HandleCancel()}
          onOk={() => setVisiblePopup(false)}
          okText="Continue"
          cancelText="Cancel"
        >
          <S.PopUpContainer>
            <div className="popup-title">
              Thanks for completing profile.
              <br /> You have got 1 free ticket!
            </div>
            <div>
              <img src={Img.StarIcon} alt="fire" width={132} />
            </div>
          </S.PopUpContainer>
        </PopUp>
      </S.Wrapper> */}
    </>
  );
};

export default Profile;
